import { SidebarMenu } from '../../core/interfaces/sidebar-menu';

export const MENU: SidebarMenu[] = [
  // ===== DASHBOARD =====
  {
    id: 1,
    label: 'MENUITEMS.DASHBOARD.TEXT',
    isTitle: true,
  },
  {
    id: 2,
    label: 'MENUITEMS.DASHBOARD_PAGE.TEXT',
    icon: '../../assets/icons/grid.svg',
    link: 'dashboard',
  },
  // MVP: Analytics not in scope
  // {
  //   id: 3,
  //   label: 'MENUITEMS.ANALYTICS.TEXT',
  //   icon: '../../assets/icons/analytic.svg',
  //   link: 'analytics',
  //   accessArea: 'analytics',
  // },

  // ===== BOOKINGS =====
  {
    id: 10,
    label: 'MENUITEMS.BOOKINGS_SECTION.TEXT',
    isTitle: true,
  },
  {
    id: 11,
    label: 'MENUITEMS.BOOKING_REQUESTS.TEXT',
    icon: '../../assets/icons/booking-request.svg',
    link: 'bookings',
    accessArea: 'bookings',
  },
  // MVP: Booking guarantee not in scope
  // {
  //   id: 12,
  //   label: 'MENUITEMS.FAILED_GUARANTEES.TEXT',
  //   icon: '../../assets/icons/cancelation.svg',
  //   link: 'failed-guarantees',
  //   accessArea: 'bookings',
  // },

  // ===== AVAILABILITY & PRICING =====
  {
    id: 20,
    label: 'MENUITEMS.AVAILABILITY_PRICING.TEXT',
    isTitle: true,
  },
  {
    id: 21,
    label: 'MENUITEMS.AVAILABILITY.TEXT',
    icon: '../../assets/icons/calendar.svg',
    link: 'availability',
    accessArea: 'availability-pricing',
  },
  {
    id: 22,
    label: 'MENUITEMS.YIELDING.TEXT',
    icon: '../../assets/icons/yielding.svg',
    link: 'yielding-tools',
    accessArea: 'availability-pricing',
    requiresHotelSetting: ['yield_price', 'last_minute_yielding'],
  },
  {
    id: 23,
    label: 'MENUITEMS.MLOS.TEXT',
    icon: '../../assets/icons/settings.svg',
    link: 'mlos',
    accessArea: 'availability-pricing',
    requiresHotelSetting: 'weekend_deals',
  },
  {
    id: 24,
    label: 'MENUITEMS.EXTRABEDS.TEXT',
    icon: '../../assets/icons/extrabeds.svg',
    link: 'extra-beds',
    accessArea: 'availability-pricing',
  },
  {
    id: 25,
    label: 'MENUITEMS.EXTRA_SERVICE.TEXT',
    icon: '../../assets/icons/settings.svg',
    link: 'services',
    accessArea: 'availability-pricing',
  },

  // ===== HOTEL PROFILE =====
  {
    id: 40,
    label: 'MENUITEMS.HOTEL_PROFILE.TEXT',
    isTitle: true,
  },
  {
    id: 41,
    label: 'MENUITEMS.INFO.TEXT',
    icon: '../../assets/icons/info.svg',
    link: 'hotel-information',
    accessArea: 'hotel-profile',
  },
  {
    id: 42,
    label: 'MENUITEMS.CONTACT.TEXT',
    icon: '../../assets/icons/contact.svg',
    link: 'contact-information',
    accessArea: 'hotel-profile',
  },
  {
    id: 43,
    label: 'MENUITEMS.ROOMS.TEXT',
    icon: '../../assets/icons/extrabeds.svg',
    link: 'rooms',
    accessArea: 'hotel-profile',
    // add-room and room-edit are sibling routes, not children of /rooms
    activeRoutes: ['add-room', 'room-edit'],
  },
  {
    id: 44,
    label: 'MENUITEMS.FEATURES.LIST.AMENITIES.TEXT',
    icon: '../../assets/icons/amenities.svg',
    link: 'amenities',
    accessArea: 'hotel-profile',
  },
  {
    id: 45,
    label: 'MENUITEMS.FEATURES.LIST.ACTIVITIES.TEXT',
    icon: '../../assets/icons/activities.svg',
    link: 'activities',
    accessArea: 'hotel-profile',
  },
  {
    id: 46,
    label: 'MENUITEMS.FEATURES.LIST.THEMES.TEXT',
    icon: '../../assets/icons/themes.svg',
    link: 'themes',
    accessArea: 'hotel-profile',
  },

  // ===== POLICIES & PAYMENTS =====
  {
    id: 30,
    label: 'MENUITEMS.POLICIES_PAYMENTS.TEXT',
    isTitle: true,
  },
  {
    id: 31,
    label: 'MENUITEMS.CANCELATION.TEXT',
    icon: '../../assets/icons/cancelation.svg',
    link: 'cancelation-policy',
    accessArea: 'policies-payments',
  },
  {
    id: 32,
    label: 'MENUITEMS.PAYMENTS.TEXT',
    icon: '../../assets/icons/payments.svg',
    link: 'payments',
    accessArea: 'policies-payments',
    hideForLabel: 'no_eguma',
  },
  {
    id: 33,
    label: 'MENUITEMS.MESSAGES.TEXT',
    icon: '../../assets/icons/contact.svg',
    link: 'messages',
    accessArea: 'policies-payments',
  },

  // ===== CONTENT & MEDIA =====
  {
    id: 50,
    label: 'MENUITEMS.CONTENT_MEDIA.TEXT',
    isTitle: true,
  },
  {
    id: 51,
    label: 'MENUITEMS.DESC.TEXT',
    icon: '../../assets/icons/description.svg',
    link: 'hotel-description',
    accessArea: 'content-media',
  },
  {
    id: 52,
    label: 'hotel_info.hotel_gallery',
    icon: '../../assets/images/gallery.svg',
    link: 'hotel-gallery',
    accessArea: 'content-media',
  },
  // Moved here from the Super Admin section — still super-admin only
  {
    id: 88,
    label: 'MENUITEMS.USPS.TEXT',
    icon: '../../assets/icons/usp.svg',
    link: 'usp',
    internalOnly: true,
    superAdminOnly: true,
  },
  {
    id: 54,
    label: 'MENUITEMS.SEO.TEXT',
    icon: '../../assets/icons/SEO.svg',
    link: 'seo-content',
    internalOnly: true,
  },
  {
    id: 86,
    label: 'MENUITEMS.USPS.TEXT',
    icon: '../../assets/icons/usp.svg',
    link: 'usp',
    internalOnly: true,
    superAdminOnly: true,
  },

  // ===== ADMINISTRATION =====
  {
    id: 70,
    label: 'MENUITEMS.ADMINISTRATION.TEXT',
    isTitle: true,
  },
  {
    id: 71,
    label: 'MENUITEMS.CONFIG.TEXT',
    icon: '../../assets/icons/settings.svg',
    link: 'hotel-settings',
    internalOnly: true,
  },
  {
    id: 72,
    label: 'MENUITEMS.HOTEL_MANAGER.TEXT',
    icon: '../../assets/icons/hotel-managers.svg',
    link: 'hotel-managers',
    accessArea: 'user-management',
  },
  {
    id: 74,
    label: 'MENUITEMS.HOTEL_DOCUMENTS.TEXT',
    icon: '../../assets/icons/documents.svg',
    link: 'hotel-documents',
    accessArea: 'documents',
  },

  // ===== INTERNAL ONLY =====
  {
    id: 80,
    label: 'MENUITEMS.SUPER_ADMIN.TEXT',
    isTitle: true,
    internalOnly: true,
  },
  {
    id: 13,
    label: 'MENUITEMS.ALL_BOOKINGS.TEXT',
    icon: '../../assets/icons/list-check.svg',
    link: 'all-bookings',
    internalOnly: true,
    superAdminOnly: true,
  },
  {
    id: 89,
    label: 'MENUITEMS.ALL_HOTELS.TEXT',
    icon: '../../assets/icons/hotel-creation.svg',
    link: 'all-hotels',
    internalOnly: true,
    superAdminOnly: true,
  },
  {
    id: 82,
    label: 'MENUITEMS.EXTRANET_USERS.TEXT',
    icon: '../../assets/icons/users.svg',
    link: 'extranet-users',
    internalOnly: true,
    superAdminOnly: true,
  },
  {
    id: 89,
    label: 'MENUITEMS.ALL_HOTEL_MANAGERS.TEXT',
    icon: '../../assets/icons/hotel-managers.svg',
    link: 'all-hotel-managers',
    internalOnly: true,
    superAdminOnly: true,
  },
  {
    id: 85,
    label: 'MENUITEMS.HOTEL_CREATION.TEXT',
    icon: '../../assets/icons/hotel-creation.svg',
    link: 'hotel-creation',
    internalOnly: true,
    superAdminOnly: true,
  },
  {
    id: 84,
    label: 'MENUITEMS.ONBOARDING_REQUESTS.TEXT',
    icon: '../../assets/icons/list-check.svg',
    link: 'onboarding-requests',
    internalOnly: true,
  },
  {
    id: 81,
    label: 'MENUITEMS.DOCUMENTS.TEXT',
    icon: '../../assets/icons/documents.svg',
    link: 'documents',
    internalOnly: true,
    superAdminOnly: true,
  },
  {
    id: 83,
    label: 'MENUITEMS.HELP_DOCS.TEXT',
    icon: '../../assets/icons/concierge.svg',
    link: 'concierge-knowledge-base',
    internalOnly: true,
  },

  // ===== ARI TOOLS AND LOGS (INTERNAL — ANY ROLE) =====
  {
    id: 93,
    label: 'MENUITEMS.ARI_TOOLS.TEXT',
    isTitle: true,
    internalOnly: true,
  },
  {
    id: 90,
    label: 'MENUITEMS.ARI_MONITOR.TEXT',
    icon: '../../assets/icons/analytic.svg',
    link: 'ari-monitor',
    internalOnly: true,
  },
  {
    id: 91,
    label: 'MENUITEMS.ARI_LOG.TEXT',
    icon: '../../assets/icons/activities.svg',
    link: 'ari-log',
    internalOnly: true,
  },
  {
    id: 92,
    label: 'MENUITEMS.ACTIVITY_LOGS.TEXT',
    icon: '../../assets/icons/activities.svg',
    link: 'activity-logs',
    internalOnly: true,
    superAdminOnly: true,
  },
  {
    id: 86,
    label: 'MENUITEMS.BOOKING_LOGS.TEXT',
    icon: '../../assets/icons/booking-request.svg',
    link: 'booking-logs',
    internalOnly: true,
    superAdminOnly: true,
  },
  {
    id: 87,
    label: 'MENUITEMS.CHANNEL_MANAGER_LOGS.TEXT',
    icon: '../../assets/icons/activities.svg',
    link: 'channel-manager-logs',
    internalOnly: true,
    superAdminOnly: true,
  },
];

// Bottom fixed menu items (handled separately in sidebar component)
export const BOTTOM_MENU: SidebarMenu[] = [
  {
    id: 90,
    label: 'MENUITEMS.MY_PROFILE.TEXT',
    icon: '../../assets/icons/user.svg',
    link: 'user-profile',
    absolute: true,
  },
  {
    id: 91,
    label: 'MENUITEMS.NOTIFICATIONS.TEXT',
    icon: '../../assets/images/notifications.svg',
    link: 'notifications',
    absolute: true,
  },
  {
    id: 92,
    label: 'MENUITEMS.HELP_SUPPORT.TEXT',
    icon: '../../assets/icons/help-support.svg',
    link: 'help',
  },
];
